/**
 * Función para cargar recetas de una historia clínica
 * @param {string} historiaId - ID de la historia clínica
 * @param {Function} getValoresCampo - Función para obtener valores de la historia clínica
 * @param {Function} setRecetas - Función para actualizar el estado de recetas
 */
export const cargarRecetas = async (historiaId, getValoresCampo, setRecetas) => {
  try {
    // Re-obtener los datos de la historia clínica para obtener las recetas actualizadas
    console.log('Recargando datos de la historia clínica para obtener recetas:', historiaId);
    const response = await getValoresCampo(historiaId);
    
    if (response.data && response.data.data) {
      const historiaActualizada = response.data.data;
      console.log('Historia clínica recargada:', historiaActualizada);
      
      // Buscar recetas directamente en la historia clínica
      if (historiaActualizada.recetas && historiaActualizada.recetas.length > 0) {
        console.log('Recetas actualizadas encontradas:', historiaActualizada.recetas);
        setRecetas(historiaActualizada.recetas);
        return;
      }
      
      // Buscar recetas en los diagnósticos
      if (historiaActualizada.diagnosticos) {
        const recetasEnDiagnosticos = [];
        historiaActualizada.diagnosticos.forEach(diagnostico => {
          if (diagnostico.recetas && diagnostico.recetas.length > 0) {
            recetasEnDiagnosticos.push(...diagnostico.recetas);
          }
        });
        
        if (recetasEnDiagnosticos.length > 0) {
          console.log('Recetas actualizadas en diagnósticos:', recetasEnDiagnosticos);
          setRecetas(recetasEnDiagnosticos);
          return;
        }
      }
      
      console.log('No se encontraron recetas actualizadas');
    }
  } catch (error) {
    console.error('Error al cargar recetas:', error);
  }
};